module.exports = __webpack_public_path__ + "img/img_onboarding_failed.b6e9aba6.svg";